<template>
  <page-side-bar-menu :menus="menus"></page-side-bar-menu>
</template>

<script>
import PageSideBarMenu from "@/components/PageSideBarMenu";

export default {
  name: "Sidebar",
  data() {
    return {
      menus: [
        {title: 'Facility1', active: this.isActive(1), 'url': '/facilities/facility'},
        {title: 'Facility2', active: this.isActive(2), 'url': '/facilities/facility'},
        {title: 'Facility3', active: this.isActive(3), 'url': '/facilities/facility'},

      ]
    }
  },
  props: {
    active: {
      default: 1,
      type: Number
    }
  },
  methods: {
    isActive(index) {
      return this.active === index;
    }
  },
  components: {
    PageSideBarMenu
  }
}
</script>

<style scoped>

</style>
